export const TON_CONNECT_MANIFEST_URL =
  'https://pd-static.playdeck.io/static/pd-tonconnect2.json';
